export default {
    message: {
        'header': {
            'online': 'عبر الانترنت'
        },
        'footer': {
            'home': 'الصفحة الرئيسية',
            'points': 'نقاط',
            'vip_zone': 'منطقة VIP',
            'order': 'ترتيب',
            'account': 'حساب'
        },
        'index': {
            'notice1': "مبروك للاعب",
            'notice2': "'فاز بالمشاركة",
            'notice3': "فلنهنئه!",
            'hot_spot': 'بقعة ساخنة',
            'all_goods': 'جميع السلع',
            'promotion_type': 'نوع الترويج',
            'partners': 'شركاء',
            'announcement': 'الإعلان',
            'cancel': 'يلغي',
            'travel_to': 'سافرها',
            'ok': 'نعم'
        },
        'goods': {
            'name1': 'استرداد مزدوج',
            'name2': 'عوائد نقدية x2',
            'name3': 'استرداد 70 مرة (VIP1)',
            'name4': 'عوائد نقدية × 72'
        },
        'img': {
            'banner1': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/b1e3c2a662e7333346ef1446db67b4c4.jpeg',
            'banner2': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/c9bf70863920f2a2ac53de21510d71c0.jpeg',
            'banner3': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/069a377136fa1234618c073b166f7ddd.jpeg',
            'banner4': 'https://manage.im2015.com//uploads/attach/2020/03/20200307/4a31597de7b1cc2674314bd8644415f2.jpg',
            'goods_img_10': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/a416c1aa63c2ca77eefa6cd89f376fc0.jpeg',
            'goods_img_50': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5ecd1c7981b5a4b58aed1e761e388ec7.jpeg',
            'goods_img_5': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/91e6995aeab9e5642b09289981288bd5.jpeg',
            'goods_img_150': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/1d5e4e5c3f6cb2e75a773f2c4bfaf014.jpeg',
            'goods_img_25': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/86d508dec4193df34ca3d10ec08eca8b.jpeg',
            'goods_img_500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/81f89dadca780f51c92416a95ee3328c.jpeg',
            'goods_img_1500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/69a61a0dfd4998c560b96500d41f9c5f.jpeg',
            'goods_img_2500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5f47a07b067b6e3acc27a1e384572a69.jpeg',
            'goods_img_return': 'https://zhouyaoming.in2015.com//uploads/attach/2021/06/20210615/f5c725953f90a25e5111bd5b14d4952f.png'
        },
        'detail': {
            'please_select': 'الرجاء التحديد',
            'product_description': 'وصف المنتج',
            'check_out': 'الدفع',
            'original_price': 'السعر الأصلي',
            'inventory': 'المخزون',
            'sold': 'مباع',
            'tip_start': 'يمكن ترقية نجاح الترويج إلى سلع ذات قيمة عالية',
            'tip_end': ' عملة مجانية',
            'quantity': 'كمية',
            'total_price': 'السعر الكلي',
            'win_rate': 'معدل الفوز',
            'predict_type': 'نوع التنبؤ',
            'member_shared': 'سيتلقى العضو المشترك',
            'share_now': 'شارك الآن',
            'copy_the_link': 'انسخ الرابط',
            'send_to_friend': 'أرسل إلى صديق',
            'copy_success': 'نسخ النجاح',
            'copy_error': 'خطأ في النسخ'
        },
        'integral': {
            'title': 'منطقة تبادل النقاط',
            'search': 'ابحث عن معلومات المنتج',
            'points': 'نقاط'
        },
        'vip_zone': {
            'title': 'قائمة البضائع VIP',
            'price': 'سعر',
            'sales_volume': 'حجم المبيعات'
        },
        'login': {
            'account_login': ['تسجل الدخول'],
            'login': 'تسجيل الدخول',
            'phone': 'أدخل رقم هاتفك',
            'pwd': 'أدخل كلمة المرور الخاصة بك',
            'no_account': 'لديك حساب موجود؟',
            'forgot_password': 'هل نسيت كلمة السر',
            'register': 'يسجل'
        },
        'reset_pwd': {
            'title': 'استرجاع كلمة السر',
            'get_verification_code': 'احصل على رمز التحقق',
            'confirm': 'يتأكد',
            'verification_code': 'شيفرة التأكيد',
            'your_new_pwd': 'كلمة سرك الجديدة',
            'reload': 'إعادة تحميل',
            'msg_phone': 'يرجى إدخال رقم الهاتف الخاص بك'
        },
        'register': {
            'register_account': 'تسجيل حساب',
            'account': 'رقم هاتف',
            'pwd': 'كلمة سر الدخول',
            'con_pwd': 'تأكيد كلمة المرور',
            'register': 'تسجيل',
            'tip_account': 'لديك حساب موجود؟',
            'by_click': 'بالضغط على" تسجيل "أوافق على مركز تسوق ممتع',
            'privacy_policy': 'سياسة خاصة',
            'tip_wrong': '*رقم الهاتف المحمول الخاطئ لن يتمكن من استخدام الموقع بشكل طبيعي.',
            'msg_phone': 'خطأ تنسيق الهاتف'
        },
        'order': {
            'submit_order': 'أكد الطلب',
            'item': 'غرض',
            'payment_method': 'طريقة الدفع او السداد',
            'pay_via_balance': 'الدفع عن طريق الرصيد',
            'balance_available': 'الرصيد المتاح',
            'total_price': 'السعر الكلي',
            'total': 'المجموع',
            'check_out': 'الدفع',
            'msg_param': 'المعلمة خاطئة',
            'msg_order_field': 'فشل تحميل بيانات الطلب',
            'msg_select_payment': 'الرجاء تحديد طريقة الدفع',
            'tip_create_order': 'إنشاء أمر ...',
            'payment_succeeded': 'نجح الدفع',
            'payment_fail': 'فشلت عملية الدفع',
            'order_no': 'رقم الطلب',
            'order_time': 'وقت الطلب',
            'other': 'آخر',
            'total_amount': 'المبلغ الإجمالي',
            'failure_reason': 'سبب الفشل',
            'view_payment_results': 'عرض نتائج الدفع',
            'payment_failed_to_repay': 'فشل السداد',
            'top_up': 'فوق حتى',
            'hot_spot': 'بقعة ساخنة',
            'back_home': 'العودة إلى المنزل',
            'msg_create_success': 'تم إنشاء الطلب بنجاح',
            'confirm_title': 'يدفع',
            'confirm_msg': 'عملية الدفع فشلت,',
            'confirm_cancel': 'يلغي',
            'confirm_top_up': 'فوق حتى',
            'game_odd': 'الفردية',
            'game_even': 'حتى في',
            'game_title': 'فردي او زوجي',
            'game_select_title': 'حدد النتيجة المتوقعة الخاصة بك',
            'game_odd_number': 'عدد فردي',
            'game_even_number': 'رقم زوجي',
            'game_confirm_selection': 'تأكيد الاختيار',
            'game_opening_time': 'وقت مفتوح',
            'game_issue': 'مشكلة',
            'game_number': 'عدد',
            'game_results': 'نتائج',
            'game_submit_err': 'خطأ: معرف الطلب غير موجود!',
            'game_choose_least': 'الرجاء اختيار واحد على الأقل!',
            'game_success': 'النجاح',
            'game_error': 'خطأ',
            'game_confirm': 'يتأكد',
            'game_confirm_title': 'رسالة',
            'game_confirm_msg': 'هل أنت متأكد من تحديد هذا؟',
            'game_confirm_cancel': 'إلغاء',
            'chart': 'جدول',
            'close': 'قريب',
            'bulls_eye': 'إصابة دقيقة للهدف',
            'trend_recent': 'اتجاه الخمسين فترة الأخيرة',
            'number': 'عدد',
            'times_without': 'مرات بدون',
            'bet': 'رهان'
        },
        'my_order': {
            'title': 'طلبي',
            'operated': 'تعمل',
            'receive': 'تسلم',
            'completed': 'مكتمل',
            'converted': 'محولة',
            'refund': 'استرداد',
            'item_total_amount': 'البند ， المبلغ الإجمالي',
            'picking_up': 'يختار أو ينتقي',
            'redeem_points': 'استبدال النقاط',
            'processing_pick_up': 'تجهيز لالتقاط',
            'hot_spot': 'بقعة ساخنة',
            'view_details': 'عرض التفاصيل',
            'check_tracking': 'تحقق من معلومات التتبع',
            'confirm_receival': 'تأكيد الاستلام',
            'receipt': 'إيصال',
            'cancel': 'يلغي',
            'confirm_pick_up': 'تأكيد الاستلام',
            'not_sales': 'ليس في المبيعات بعد',
            'sales_failed': 'فشل المبيعات',
            'sales_success': 'نجاح المبيعات',
            'waiting_draw': 'في انتظار التعادل',
            'bonus_countdown': 'العد التنازلي المكافأة',
            'redeem_success': 'استرداد النجاح',
            'awarded': 'منحت',
            'points': 'نقاط',
            'fee': 'مصاريف',
            'cash': 'السيولة النقدية',
            'sure': 'بالتأكيد',
            'detail_title': 'تفاصيل الطلب',
            'detail_copy': 'ينسخ',
            'detail_order_no': 'رقم الطلب',
            'detail_order_time': 'وقت الطلب',
            'detail_type_order': 'نوع الأمر',
            'detail_status_payment': 'حالة الدفع',
            'detail_have_pay': 'يجب أن تدفع',
            'detail_did_pay': 'لم يدفع',
            'detail_promotion_status': 'حالة الترقية',
            'detail_promotion_period': 'فترة العرض',
            'detail_promotion_games': 'ألعاب الترويج',
            'detail_opening_time': 'وقت مفتوح',
            'detail_my_choice': 'اختياري',
            'detail_lottery_numbers': 'أرقام اليانصيب',
            'detail_payment_method': 'طريقة الدفع او السداد',
            'detail_total_amount': 'المبلغ الإجمالي',
            'detail_amount_paid': 'المبلغ المدفوع',
            'detail_re_order': 'إعادة الطلب'
        },
        'user': {
            'account': 'حساب',
            'available_balance': 'الرصيد المتوفر',
            'my_points': 'نقاطي',
            'active_code': 'رمز فعال',
            'your_code': 'ادخل رمزك',
            'msg_code': 'يرجى ملء رمز الصرف',
            'ok': 'نعم',
            'deposit': 'الوديعة',
            'withdraw': 'ينسحب',
            'confirm_title': 'تأكيد التغيير؟',
            'confirm_msg': 'تغيير الصورة الرمزية للمستخدم',
            'confirm_cancel': 'يلغي',
            'confirm_ok': 'يتأكد',
            'cancelled': 'ألغيت',
            'profile_title': 'ملف تعريفي للمستخدم',
            'profile_manage_account': 'إدارة حسابي',
            'profile_nickname': 'اسم الشهرة',
            'profile_real_name': 'الاسم الحقيقي',
            'profile_email': 'بريد الالكتروني',
            'profile_phone': 'هاتف',
            'profile_password': 'كلمه السر',
            'profile_click_change_password': 'انقر فوق تغيير كلمة المرور',
            'profile_save_the_change': 'احفظ التغيير',
            'profile_log_out': 'تسجيل خروج',
            'profile_confirm_title': 'تسجيل خروج',
            'profile_confirm_msg': 'تأكيد الخروج؟',
            'profile_confirm_cancel': 'يلغي',
            'profile_confirm': 'يتأكد',
            'change_password_title': 'تغيير كلمة المرور',
            'change_password_current_pwd': 'أدخل كلمة المرور الحالية',
            'change_password_set_new_pwd': 'قم بتعيين كلمة المرور الجديدة الخاصة بك',
            'change_password_confirm_new_pwd': 'تأكيد كلمة المرور الجديدة',
            'change_password_confirm_change': 'تأكيد التغيير',
            'change_password_msg_current_pwd': 'الرجاء إدخال كلمة المرور الحالية',
            'change_password_msg_new_pwd': 'الرجاء إدخال كلمة المرور الجديدة',
            'change_password_msg_new_pwd_again': 'الرجاء إدخال كلمة المرور الجديدة مرة أخرى',
            'change_password_msg_not_match': 'كلمة السر غير متطابقة',
            'user_rank_title': 'سجل افتتاح الجائزة',
            'user_menu_bulletin': 'نشرة',
            'user_menu_vip': 'VIP',
            'user_menu_binance_pay': 'دفع بينانس',
            'user_menu_agent': 'وكيلات',
            'user_menu_balance_details': 'تفاصيل الرصيد',
            'user_menu_lottery_record': 'سجل اليانصيب',
            'user_menu_service': 'خدمة',
            'user_menu_about_us': 'معلومات عنا'
        },
        'balance_detail': {
            'title': 'تفاصيل الرصيد',
            'total_amount': 'المبلغ الإجمالي',
            'top_up': 'فوق حتى',
            'accumulated_withdrawal': 'الانسحاب المتراكم',
            'bill_record': 'سجل الفاتورة',
            'consumption_records': 'سجلات الاستهلاك',
            'recharge_records': 'إعادة تعبئة السجلات',
            'points_center': 'مركز النقاط',
            'sign_in': 'تسجيل الدخول لجمع النقاط',
            'upgrade_level': 'قم بترقية المستويات لفتح المزيد من اللعب！'
        },
        'my_pay': {
            'title': 'ربط المحفظة الإلكترونية',
            'phone': 'هاتف',
            'phone_plac': 'أدخل هاتفك',
            'binance_id': 'معرف Binance',
            'binance_id_plac': 'أدخل معرف Binance',
            'pay_nickname': 'دفع لقب',
            'pay_id': 'معرف الدفع',
            'pay_id_plac': 'أدخل معرف الدفع',
            'tip': 'يرجى التأكد من صحة جميع المعلومات ، وإلا فلن تتمكن من السحب.',
            'bind': 'ربط',
            'edit': 'يحرر',
            'msg_nickname': 'الرجاء إدخال لقب الدفع',
            'confirm_msg': "<b style='color: red'>ملحوظة</b>: لا يمكن تعديل لقب الدفع إلا مرة واحدة! ! !<br>لقب الدفع:",
            'confirm_title': 'تحرير لقب Binance Pay',
            'confirm_cancel': 'يلغي',
            'confirm_cancelled': 'ألغيت',
            'confirm_confirm': 'يتأكد',
            'msg_phone': 'الرجاء إدخال رقم الهاتف',
            'msg_binance_id': 'الرجاء إدخال معرف Binance',
            'msg_binance_id_format': 'خطأ تنسيق معرف Binance',
            'msg_pay_nickname': 'الرجاء إدخال لقب الدفع',
            'msg_pay_id': 'الرجاء إدخال معرف الدفع',
            'msg_pay_id_format': 'خطأ في تنسيق معرف الدفع',
            'msg_pay_id_length': 'خطأ في طول معرف الدفع',
            'msg_binance_pay': 'معرف Binance ليس معرف الدفع ، يمكن العثور على معرف الدفع في صفحة الاستلام.',
            'msg_confirm_title': 'معلومات تأكيد الدفع بينانس',
            'msg_confirm_msg1': 'لقب الدفع الخاص بك',
            'msg_confirm_msg2': 'معرف الدفع الخاص بك',
            'msg_confirm_msg3': 'ملاحظة: بمجرد التأكيد ، لا يمكن فك الارتباط!',
            'msg_confirm_cancel': 'يلغي',
            'msg_confirm_cancelled': 'ألغيت',
            'msg_confirm': 'يتأكد',
            'bind_success_msg': 'رابط النجاح ， تحصل عليه'
        },
        'user_bill': {
            'title': 'تفاصيل الرصيد',
            'all': 'الجميع',
            'consumption': 'استهلاك',
            'recharge': 'تعبئة رصيد',
            'income': 'دخل'
        },
        'user_integral': {
            'title': 'تفاصيل النقاط',
            'current_points': 'النقاط الحالية',
            'accumulated_points': 'النقاط المتراكمة',
            'accumulated_consumption': 'الاستهلاك المتراكم',
            'obtained_today': 'تم الحصول عليها اليوم',
            'details_points': 'تفاصيل النقاط',
            'increase_points': 'زيادة النقاط',
            'points_rewarded_purchasing': 'نقاط مكافأة لشراء عنصر',
            'earn_points': 'اكسب النقاط',
            'points_rewarded_sign': 'النقاط الممنوحة لتسجيل الدخول اليومي',
            'sign_points': 'نقاط',
            'sign_details': 'تفاصيل',
            'sign_signed': 'وقعت',
            'sign_sign': 'لافتة',
            'sign_accumulated_sign': 'تراكم تسجيل الدخول',
            'sign_days': 'أيام',
            'sign_tip2_s': 'يقال أن',
            'sign_tip2_e': ' سيحصل يوم تسجيل الدخول المستمر على نقاط ضخمة ، لا تنس تسجيل الدخول ~~~',
            'sign_click_load_more': 'انقر لتحميل المزيد',
            'sign_success': 'تسجيل الدخول بنجاح',
            'sign_awarded': 'منحت',
            'sign_sure': 'بالتأكيد',
            'sign_cnum': ["صفر", "واحد", "اثنين", "ثلاثة", "أربعة", "خمسة", "ستة", "سبعة", "ثمانية", "تسع"],
            'sign_msg_signed': 'لقد قمت بتسجيل الدخول اليوم!',
            'detail_title': 'طلب للحصول على نقاط',
            'detail_phone': 'هاتف',
            'detail_payment_method': 'طريقة الدفع او السداد',
            'detail_pay_with_points': 'ادفع بالنقاط',
            'detail_available_points': 'النقاط المتاحة',
            'detail_total': 'المجموع',
            'detail_points': 'نقاط',
            'detail_check_out': 'الدفع',
            'pay_points': 'ادفع النقاط',
            'detail_parameter_wrong': 'المعلمة خاطئة',
            'detail_failed_data': 'فشل تحميل بيانات الطلب',
            'detail_creating_order': 'إنشاء أمر ...',
            'detail_creating_order_fail': 'فشل إنشاء الأمر',
            'detail_status_title': 'التبادل الناجح للبضائع',
            'detail_status_check_mailbox': 'يرجى التحقق من صندوق البريد الخاص بك ، وسنقوم بتسليم المنتج في غضون 24 ساعة.',
            'detail_status_view_order': 'لعرض الطلب',
            'detail_status_back_home': 'العودة إلى المنزل',
            'detail_points_title': 'تفاصيل النقاط',
            'my_order_points_title': 'ترتيب نقاطي'
        },
        'recharge': {
            'title': 'إرسال طلب إعادة التعبئة',
            'first_deposit': 'مكافأة الإيداع الأول',
            'use_binance': 'استخدم Binance',
            'choose_amount': 'الرجاء اختيار المبلغ والمتابعة',
            'current_balance': 'ملاحظة: الرصيد الحالي',
            'confirm_top_up': 'تأكيد التعبئة',
            'application_details': 'اشحن تفاصيل التطبيق',
            'order_number': 'رقم الأمر',
            'application_time': 'وقت التطبيق',
            'top_up_amount': 'مبلغ التعبئة',
            'top_up_status': 'حالة التعبئة',
            'reviewing': 'المراجعة',
            'application_success': 'نجاح التطبيق',
            'application_failed': 'فشل التطبيق',
            'msg_bind_binance': 'الرجاء ربط Binance Pay',
            'msg_minimum_bank': '100 كحد أدنى لتعبئة الرصيد',
            'msg_minimum_binance': '1 على الأقل لتعبئة الرصيد',
            'msg_enter_top_up_amount': 'الرجاء إدخال مبلغ الشحن',
            'confirm_title': 'قم بتأكيد تفاصيل الإيداع',
            'confirm_verify_information': 'يرجى التحقق من المعلومات',
            'confirm_tip': 'أرسل الأموال إلى أي من الحسابات التالية باستخدام Binance Pay المقيد ، انقر فوق الزاوية اليمنى العليا لعرض البرنامج التعليمي.',
            'confirm_our_pay_id': 'معرف الدفع الخاص بنا',
            'confirm_copy': 'ينسخ',
            'confirm_top_up_amount': 'مبلغ التعبئة',
            'confirm_confirm_top_up': 'تأكيد التعبئة',
            'confirm_msg_copy': 'نسخ النجاح',
            'confirm_msg_enter_amount': 'الرجاء إدخال المبلغ لإعادة الشحن',
            'confirm_transfer_amount': 'مبلغ التحويل لا يقل عن 1',
            'confirm_alert_mes': 'يرجى تأكيد استخدام دفعة binance الملزمة للدفع لنا.<b style=\'color: red\'> الرجاء الانتظار لمدة 5-10 دقائق للوصول.</b>إذا كان لديك أي أسئلة ، يرجى الاتصال بخدمة العملاء في الوقت المناسب.',
            'confirm_alert_title': 'إرسال طلب إعادة التعبئة',
            'confirm_alert_cancel': 'يلغي',
            'confirm_alert_msg_cancelled': 'ألغيت',
            'confirm_alert_confirm': 'يتأكد'
        },
        'withdrawal': {
            'title': 'ينسحب',
            'link_now_tip': 'لم تقم بربط المحفظة الإلكترونية بعد ، يرجى ربط وتقديم طلب السحب مرة أخرى.',
            'link_now': 'رابط الآن',
            'withdrawal_account': 'حساب السحب',
            'phone': 'هاتف',
            'binance_id': 'معرف Binance',
            'nickname': 'اسم الشهرة',
            'pay_id': 'معرف الدفع',
            'withdraw_amount': 'سحب المبلغ',
            'balance': 'الرصيد',
            'processing_fee': 'كلفة المعالجة',
            'actual_amount': 'الكمية الفعلية',
            'msg_withdrawal_account': 'الرجاء تحديد حساب السحب',
            'msg_fill_data': 'يرجى ملء البيانات',
            'msg_phone': 'الرجاء إدخال رقم الهاتف',
            'msg_binance_id': 'الرجاء إدخال معرف Binance',
            'msg_binance_pay_id': 'الرجاء إدخال معرف الدفع Binance',
            'msg_pay_id_err': 'خطأ في تنسيق معرف الدفع',
            'msg_withdraw_amount': 'الرجاء إدخال مبلغ السحب',
            'msg_insufficient_balance': 'رصيد غير كاف',
            'msg_mini_withdraw': '160 حد أدنى للانسحاب',
            'msg_minimum': 'الحد الأدنى',
            'msg_to_withdraw': 'لسحب',
            'audit_tip': 'تم تقديم الانسحاب في انتظار المراجعة',
            'audit_sure': 'بالتأكيد'
        },
        'user_vip': {
            'title': 'مركز الأعضاء',
            'able_purchase': 'قادرة على شراء عنصر في',
            'off': 'إيقاف',
            'level_task1': 'أكمل إيداع 1 دولار أمريكي واشترِ البضائع 50 مرة لتصبح من كبار الشخصيات!',
            'level_task2': 'رسوم السحب',
            'level_task3': 'وقت الانسحاب',
            'level_task4': 'ح',
            'vip_level_unlocked': 'تم فتح مستوى VIP',
            'higher_level_unlocked': 'مستوى أعلى مقفلة',
            'vip_upgrade_requirements': 'متطلبات ترقية VIP',
            'required_tasks': 'المهام المطلوبة',
            'select_one_below': 'الرجاء تحديد واحد مما يلي',
            'achieved': 'حقق',
            'conditions_met': 'لم تتحقق الشروط',
            'accumulated_participation': 'المشاركة المتراكمة في اللعبة',
            'achieved_top_up': 'تراكم 50 عملة معدنية',
            'exclusive_coupons': 'كوبونات حصرية',
            'more_games': 'المزيد من الألعاب',
            'need_recharge': 'تحتاج لإعادة شحن 50 عملة معدنية'
        },
        'promoter': {
            'title': 'إدارة المروج',
            'apply_agency': 'تقدم بطلب وكالة لتصبح واحد منا',
            'become_agent': 'كن وكيلا',
            'repeatedly_delayed': 'قد يتأخر التحميل ، يرجى الانتظار قليلاً وعدم النقر بشكل متكرر！',
            'current_commission': 'العمولة الحالية',
            'record': 'سجل',
            'profit_yesterday': 'ربح أمس',
            'accumulated_withdrawal': 'الانسحاب المتراكم',
            'withdraw': 'ينسحب',
            'refer_friends': 'إحالة الأصدقاء',
            'total_agent': 'إجمالي الوكيل',
            'copy_success': 'نسخ النجاح',
            'copy_error': 'خطأ في النسخ',
            'promoter_achievements': 'إنجازات المروج',
            'promoter_orders': 'أوامر المروج',
            'promoter_ranking': 'ترتيب المروج',
            'commission_ranking': 'ترتيب العمولة',
            'list_title': 'عدد الوكلاء',
            'list_number_agents': 'عدد الوكلاء',
            'list_people': 'اشخاص',
            'list_date_joined': 'تاريخ الانضمام',
            'list_item': 'غرض',
            'order_title': 'الطلبات المتراكمة',
            'order_accumulated_orders': 'الطلبات المتراكمة',
            'order_commission': 'لجنة',
            'order_time': 'وقت الطلب',
            'order_mark': 'علامة',
            'commission_title': 'إنجازات المروج',
            'commission_accumulated_commission': 'العمولة المتراكمة',
            'commission_available': 'العمولة المتاحة للسحب',
            'commission_week': 'الأعضاء الجدد هذا الأسبوع',
            'commission_month': 'الأعضاء الجدد هذا الشهر',
            'commission_achievement': 'إنجاز',
            'commission_rank_title': 'ترتيب العمولة',
            'commission_rank_current': 'ترتيبك الحالي',
            'commission_rank_yet': 'أنت لست في الترتيب بعد',
            'rank_title': 'ترتيب المروج',
            'cash_record_title': 'تفاصيل سحب العمولة',
            'cash_record_cash_out': 'سجل الصرف',
            'user_cash_title': 'سحب العمولة',
            'user_cash_not_link': 'لم تقم بربط المحفظة الإلكترونية بعد ، يرجى ربط وتقديم طلب السحب مرة أخرى.',
            'user_cash_link_now': 'رابط الآن',
            'user_cash_service_provider': 'مقدم الخدمة',
            'user_cash_select_account': 'الرجاء تحديد حساب السحب',
            'user_cash_binance_pay': 'دفع بينانس',
            'user_cash_bank_account': 'حساب البنك',
            'user_cash_bank_account_pla': 'يرجى ملء رقم حسابك المصرفي',
            'user_cash_ifsc_pla': 'يرجى إدخال رقم حساب IFSC الخاص بك',
            'user_cash_upi_pla': 'يرجى ملء رقم حساب UPI الخاص بك',
            'user_cash_withdraw': 'ينسحب',
            'user_cash_minimum': 'الحد الأدنى',
            'user_cash_to_withdraw': 'لسحب',
            'user_cash_current_commission': 'العمولة الحالية المتاحة للسحب',
            'user_cash_account': 'حساب',
            'user_cash_account_pla': 'يرجى ملء اسم مستخدم alipay الخاص بك',
            'user_cash_current_withdrawal': 'عمولة السحب الحالية',
            'user_cash_to_e_wallet': 'سحب إلى المحفظة الإلكترونية',
            'user_cash_to_balance': 'الانسحاب لتحقيق التوازن',
            'user_cash_insufficient_balance': 'رصيد غير كاف',
            'user_cash_data_format': 'البيانات بتنسيق خاطئ'
        },
        'service': {
            'title': 'سجلات الرسائل',
            'write_email': 'من فضلك اكتب لنا البريد الإلكتروني'
        }
    }
};